export default __webpack_public_path__ + "fb9c28c4a95d0b796051de257da067b1.png";